import EnglishTranslation from "./translation.json";
import newTranslation from "./sectionTranslation.json";
import quickRegisterEn from "./quickRegisterEn.json";
import registrationEn from "./Registration.json";
import forgotPasswordEn from "./forgotPasswordEn.json";
import resetPasswordEn from "./resetPasswordEn.json";
import changePasswordEn from "./changePasswordEn.json";
import quoteEn from "./quoteEn.json";
import orderLawyerInformationEn from "./orderLawyerInformationEn.json";
import propertyIdentificationEn from "./propertyIdentificationEn.json";
import purchasorMortgagorTabEn from "./purchasorMortgagorTabEn.json";
import lenderInformationEn from "./lenderInformationEn.json";
import additionalinformationEn from "./additionalInformationEn.json";
import menuEn from "./menuEn.json";
import orderSummaryEn from "./orderSummaryEn.json";
import viewOrdersEn from "./viewOrdersEn.json";
import inquiriesEn from "./inquiriesEn.json";
import PropertyTypesEn from "./PropertyTypesEn.json";
import autoAdjudicateEn from "./autoAdjudicateEn.json";
import orderStatusEn from "./orderStatusEn.json";
import downloadPoliciesEn from "./downloadPoliciesEn.json";
import accountSummaryEn from "./accountSummaryEn.json";
import orderInvoicesEn from "./orderInvoicesEn.json";
import fintracEn from "./fintracEn.json";
import QuotePropertyTypesEn from "./QuotePropertyTypesEn.json";

let translationEn = Object.assign(EnglishTranslation, newTranslation);

Object.assign(
  translationEn,
  inquiriesEn,
  PropertyTypesEn,
  quickRegisterEn,
  registrationEn,
  forgotPasswordEn,
  resetPasswordEn,
  changePasswordEn,
  orderLawyerInformationEn,
  quoteEn,
  propertyIdentificationEn,
  purchasorMortgagorTabEn,
  lenderInformationEn,
  additionalinformationEn,
  menuEn,
  orderSummaryEn,
  viewOrdersEn,
  autoAdjudicateEn,
  orderStatusEn,
  downloadPoliciesEn,
  accountSummaryEn,
  orderInvoicesEn,
  fintracEn,
  QuotePropertyTypesEn
);

export default translationEn;
